import Vue from "vue";
import VueRouter from "vue-router";
import Authenticated from "./middleware/Authenticated";
import NProgress from "nprogress";
import IsAdmin from "./middleware/IsAdmin";
NProgress.configure({ easing: "ease-out", speed: 500, showSpinner: false });

Vue.use(VueRouter);

const TestPlay = () => import("../views/game/TestPlay.vue");
const Home = () => import("../views/Home.vue");
const Favorites = () => import("../views/Favorites.vue");
const SlotsCasino = () => import("../views/SlotsCasino.vue");
const LiveCasino = () => import("../views/LiveCasino.vue");
const RecentGames = () => import("../views/RecentGames.vue");
const Play = () => import("../views/game/Play.vue");
const PageNotFound = () => import("../views/errors/PageNotFound.vue");

const Admin = () => import("../views/admin/Admin.vue");
const AdminGame = () => import("../views/admin/AdminGame.vue");
const AdminCasinoGames = () => import("../views/admin/AdminCasinoGames.vue");
const AdminCasinoManager = () => import("../views/admin/AdminCasinoManager.vue");
const FlipMaster = () => import("../views/game/FlipMaster.vue");

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/favorites",
    name: "Favorites",
    component: Favorites,
  },
  {
    path: "/slots",
    name: "Slots",
    component: SlotsCasino,
  },
  {
    path: "/live-casino",
    name: "LiveCasino",
    component: LiveCasino,
  },
  {
    path: "/recent-games",
    name: "RecentGames",
    component: RecentGames,
  },
  {
    path: "/flipmaster",
    name: "FlipMaster",
    component: FlipMaster,
  },
  {
    path: "/games/:type/play/:id",
    name: "Play",
    component: Play,
  },
  {
    path: "/admin",
    component: Admin,
    meta: { isAdmin: true },
    children: [
      {
        path: "games",
        name: "AdminGames",
        component: AdminGame,
      },
      {
        path: "casino-games",
        name: "AdminCasinoGames",
        component: AdminCasinoGames,
      },
      {
        path: "casino-manager",
        name: "AdminCasinoManager",
        component: AdminCasinoManager,
      },
    ],
  },
  {
    path: "/casino/:type/play",
    name: "CasinoTestPlayer",
    component: TestPlay,
  },
  { path: "*", component: PageNotFound },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(Authenticated);
router.beforeEach(IsAdmin);

//progressbar each navigate
router.beforeResolve((to, from, next) => {
  NProgress.start();
  next();
});
router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
